/** Display helpers. Nothing here invents a value: unknown renders as unknown. */

export const UNKNOWN = "—";

export function humanize(value: string | null | undefined): string {
  if (!value) return UNKNOWN;
  return value.replace(/[_.]/g, " ").replace(/\b\w/g, (c) => c.toUpperCase());
}

export function predicateLabel(predicate: string): string {
  return predicate.replace(/_/g, " ");
}

export function percent(value: number | string | null | undefined): string {
  if (value === null || value === undefined) return UNKNOWN;
  const numeric = typeof value === "string" ? Number.parseFloat(value) : value;
  if (Number.isNaN(numeric)) return UNKNOWN;
  return `${numeric.toFixed(numeric % 1 === 0 ? 0 : 1)}%`;
}

export function confidence(value: number | string | null | undefined): string {
  if (value === null || value === undefined) return UNKNOWN;
  const numeric = typeof value === "string" ? Number.parseFloat(value) : value;
  if (Number.isNaN(numeric)) return UNKNOWN;
  return numeric.toFixed(2);
}

export function bytes(size: number | null | undefined): string {
  if (size === null || size === undefined) return UNKNOWN;
  if (size < 1024) return `${size} B`;
  if (size < 1024 * 1024) return `${(size / 1024).toFixed(1)} KB`;
  return `${(size / (1024 * 1024)).toFixed(1)} MB`;
}

export function dateTime(value: string | null | undefined): string {
  if (!value) return UNKNOWN;
  const parsed = new Date(value);
  if (Number.isNaN(parsed.getTime())) return UNKNOWN;
  return parsed.toLocaleString(undefined, {
    year: "numeric",
    month: "short",
    day: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
}

export function relativeTime(value: string | null | undefined): string {
  if (!value) return UNKNOWN;
  const parsed = new Date(value).getTime();
  if (Number.isNaN(parsed)) return UNKNOWN;
  const seconds = Math.round((Date.now() - parsed) / 1000);
  if (seconds < 60) return "just now";
  if (seconds < 3600) return `${Math.floor(seconds / 60)}m ago`;
  if (seconds < 86400) return `${Math.floor(seconds / 3600)}h ago`;
  if (seconds < 604800) return `${Math.floor(seconds / 86400)}d ago`;
  return dateTime(value);
}

export function displayValue(value: unknown): string {
  if (value === null || value === undefined || value === "") return UNKNOWN;
  if (typeof value === "boolean") return value ? "Yes" : "No";
  if (Array.isArray(value)) return value.length ? value.map(displayValue).join(", ") : UNKNOWN;
  if (typeof value === "object") return JSON.stringify(value);
  return String(value);
}

/** SurveyJS reads dotted names as nested property paths, so names are escaped. */
export function toSurveyName(semanticId: string): string {
  return semanticId.replace(/\./g, "__");
}

export function fromSurveyName(name: string): string {
  return name.replace(/__/g, ".");
}
